const callToActionTooltipText = 'The page that visitors should be directed to if they click the "shop now" button for this video (optional)';
const MAX_PRODUCTS = 4

export { callToActionTooltipText, MAX_PRODUCTS }